import LogRocket from 'logrocket';

import { WF_DEVICE_ID_SEARCH_PARAM } from '../config/routes';
import { EVENT_STREAM_APP_TYPES, EVENT_STREAM_EVENT_TYPES } from '../config/service';
import { postSubscribeStatus, sendEventStream } from './service';
import { getUserName, getUUID } from './utils';
import { POSTHOG_PROPERTIES, TRACKER_EVENT_TYPES } from '../config/tracker';
import { pushSignUpEvent, pushLoginEvent } from './gtm';

export const SIGNUP_METHOD = {
  MANUAL: 'manual',
  GOOGLE: 'google',
  PHONE: 'phone',
};

export const SOURCE = {
  APP: 'app',
  EMBED: 'embed',
};

export const TOPIC_SIGNUP = {
  TBB_REGISTRATION_SIGNUP_FLOW: 'TBB_REGISTRATION_SIGNUP_FLOW',
  SIGN_UP_WITH_LOGIN_LINK: 'SIGN_UP_WITH_LOGIN_LINK',
  SIGN_UP_WEB_FLOW_LANDING_PAGE: 'SIGN_UP_WEB_FLOW_LANDING_PAGE',
};

export const finishProcess = async ({
  userRegistered = false,
  userRegisteredMethod = SIGNUP_METHOD.MANUAL,
  userData = {},
  optIn = false,
  wfExtensionFlow = false,
  wfedidParam,
  posthog,
  source = SOURCE.APP,
  trackerProps = {},
}) => {
  const {
    email,
  } = userData;

  const uuid = getUUID(userData);

  const method = userRegisteredMethod === SIGNUP_METHOD.MANUAL ? 'email' : userRegisteredMethod;

  if (userRegistered) {
    window.fbq?.('trackCustom', 'sign_up');
    pushSignUpEvent(userData, method);
    await postSubscribeStatus(email, optIn);
  } else {
    pushLoginEvent(userData, method);
  }

  if (posthog) {
    posthog.identify(
      uuid,
      {
        email,
        [WF_DEVICE_ID_SEARCH_PARAM]: wfedidParam,
      },
    );

    if (wfedidParam) {
      posthog.alias(uuid, wfedidParam);
    }

    posthog.capture(
      TRACKER_EVENT_TYPES.LOGIN,
      {
        [POSTHOG_PROPERTIES.METHOD]: userRegisteredMethod,
        [POSTHOG_PROPERTIES.SOURCE]: source,
        ...trackerProps,
      },
    );
  }

  LogRocket.identify(String(uuid), {
    email,
    name: getUserName(userData),
  });

  await sendEventStream({
    event: wfExtensionFlow ?
      EVENT_STREAM_EVENT_TYPES.USER_LOGGED_IN_WF_EXTENSION :
      EVENT_STREAM_EVENT_TYPES.USER_LOGGED_IN,
    application: EVENT_STREAM_APP_TYPES.TRASHIE,
  });
};
